import styles from "./LanguageSelect.module.scss";

import languageIcon from "../../../assets/images/icons/language.svg";
import selectArrow from "../../../assets/images/icons/select-arrow.svg";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { getLanguageFromLocal } from "../../../helper/language";
import useOnclickOutside from "react-cool-onclickoutside";

const LanguageSelect = () => {
  const languageItems = [
    {
      label: "English",
      value: "en",
    },
    {
      label: "Greek",
      value: "gr",
    },
  ];

  const [isOpen, setIsOpen] = useState<boolean>(false);
  const { i18n } = useTranslation();

  const ref = useOnclickOutside(() => {
    setIsOpen(false);
  });

  const handleLanguage = () => {
    setIsOpen(!isOpen);
  };

  const changeLanguageItem = (value: string) => {
    i18n.changeLanguage(value);
    setIsOpen(false);
  };

  return (
    <div ref={ref} className={styles.container}>
      <div onClick={handleLanguage} className={styles.main}>
        <div>
          <img className={styles.languageIcon} src={languageIcon} alt={"language"} />
          <span className={styles.text}>Language</span>
        </div>
        <img
          className={`${styles.arrow} ${isOpen && styles.active}`}
          src={selectArrow}
          alt={"arrow"}
        />
      </div>
      <div className={`${styles.dropdown} ${isOpen && styles.active}`}>
        <ul className={styles.list}>
          {languageItems.map((el) => (
            <li
              key={el.value}
              onClick={() => changeLanguageItem(el.value)}
              className={`${styles.item} ${getLanguageFromLocal() === el.value && styles.current}`}
            >
              {el.label}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default LanguageSelect;
